import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IEventBundle, IEventBundleConfiguration } from "../../models/configuration/bundles/IBundles";
import { hasEventBundlingChanges } from "../../utils/bundlingConfigChangeDetector";

const saveConfigEventBundleData = (configId: string, eventBundles: IEventBundle[], token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({
            type: ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA
        });

        const pluginService = new PluginService();

        try {
            const { persistedData } = getState().configEventBundles;
            const payloadToSave = {
                Configuration: {
                    Bundling: eventBundles
                }
            };

            const hasChanges = hasEventBundlingChanges(payloadToSave, persistedData);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA_SUCCESS,
                    payload: payloadToSave
                });
                return false;
            }

            const requestBody = {
                ConfigurationId: configId,
                Configuration: payloadToSave.Configuration
            };
            await pluginService.saveConfig<IEventBundleConfiguration>(token, "event-bundling", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA_SUCCESS,
                payload: payloadToSave
            });

            return true;

        } catch (error) {
            console.log("saveConfigEventBundleData --> FAILURE");
            if (error instanceof Error) {
                const payloadErrorMessage = `Failed to Save Event Bundles Configuration Data: (${error.message})`;
                dispatch({
                    type: ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA_FAILURE,
                    payload: payloadErrorMessage
                });
                throw new Error(payloadErrorMessage);
            }
        }
    }
}

export default saveConfigEventBundleData;